export default class AvisoEvaluacion {
  info = {
    nombre: String,
    fecha_poligrafo: String,
    fecha_medico: String,
    fecha_piscologia: String,
    fecha_ise: String,
    motivo_solicitud: String,
    numero_oficio: String,
    fecha_integracion: String,
  };

  id = String

  constructor(info, id) {
    this.info = info;
    this.id = id;
  }
}
